import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { downloadProtocoloFile } from 'app/services/api/user/register';
import Loader from 'app/common/Loader';
import { Dialog, DialogContent, Typography, Button } from '@mui/material';

const DownloadRates = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('downloading');

  useEffect(() => {
    downloadPdf();
  }, [navigate]);

  const downloadPdf = async () => {
    try {
      setStatus('downloading');
      
      const response = await downloadProtocoloFile();

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'Protocolo_miREP_v1.1.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(downloadUrl);
      setStatus('success');
      
      setTimeout(() => {
        navigate('/HOME');
      }, 1500);
      
    } catch (error) {
      console.error('Error descargando PDF:', error);
      setStatus('error');
    }
  };

  const handleRetry = () => {
    downloadPdf();
  };

  return (
    <Dialog open={true}>
      <DialogContent>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Loader visible={status === 'downloading'} />
          <Typography variant="body1" style={{ marginTop: '10px' }}>
            {status === 'downloading' && 'Descargando PDF...'}
            {status === 'success' && '¡PDF descargado! Redirigiendo...'}
            {status === 'error' && 'Error en la descarga'}
          </Typography>
          
          {status === 'error' && (
            <div style={{ marginTop: '15px' }}>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleRetry}
              >
                Reintentar Descarga
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadRates;